import { graphql } from '@e-socna/data-layer';

export const MyAccountPage_OneUser_QueryDocument = graphql(`
  query MyAccountPage_OneUser_Query {
    findAuthenticatedUser {
      _id
      personId
      ...UserPage_Tab_User_Fragment
      person {
        ...PersonPage_Tabs_Person_Fragment
      }
    }
  }
`);
